/* eslint-disable @typescript-eslint/no-explicit-any */
// StatusResponse enum từ backend
export enum StatusResponse {
    SUCCESS = 'success',
    FAIL = 'fail',
    FORBIDDEN = 'forbidden',
    NOTFOUND = 'notfound',
    EXISTS_USERNAME = 'exists_username',
    EXISTS_EMAIL = 'exists_email',
    USERNAME_OR_PASSWORD_IS_NOT_CORRECT = 'username_or_password_is_not_correct',
    NOT_EXISTS_ROLE = 'not_exists_role',
    TYPE_ERROR = 'type_error',
    USER_BY_ID_NOT_FOUND = 'user_by_id_not_found',
    VIDEO_BY_ID_NOT_FOUND = 'video_by_id_not_found',
    EXISTS_CATEGORY = 'exists_category',
    CATEGORY_BY_ID_NOT_FOUND = 'category_by_id_not_found',
    MOVIE_BY_ID_NOT_FOUND = 'movie_by_id_not_found',
    EXISTS_MOVIE = 'exists_movie',
    EXISTS_COUNTRY = 'exists_country',
    COUNTRY_BY_ID_NOT_FOUND = 'country_by_id_not_found',
    EXISTS_ACTOR = 'exists_actor',
    ACTOR_BY_ID_NOT_FOUND = 'actor_by_id_not_found',
    ACTOR_NOT_FOUND = 'actor_not_found',
    EXISTS_DIRECTOR = 'exists_director',
    DIRECTOR_BY_ID_NOT_FOUND = 'director_by_id_not_found',
    ERROR_CONNECT_MINIO_SERVER = 'error_connect_minio_server',
    OBJECT_ID_NOT_VALID = 'object_id_not_valid',
    ROLE_NOT_EXISTS = 'role_not_exists',
    EXISTS_DOMAIN = 'exists_domain',
    DOMAIN_BY_ID_NOT_FOUND = 'domain_by_id_not_found',
    EXISTS_GROUP_DOMAIN = 'exists_group_domain',
    GROUP_DOMAIN_BY_ID_NOT_FOUND = 'group_domain_by_id_not_found',
    YOU_NEED_TO_PROVIDE_ORIGIN = 'you_need_to_provide_origin',
    YOUR_SITE_NOT_FOUND = 'your_site_not_found',
    EXISTS_DYNADOT = 'exists_dynadot',
    DYNADOT_BY_ID_NOT_FOUND = 'dynadot_by_id_not_found',
    EXISTS_NAME = 'exists_name',
    NAME_BY_ID_NOT_FOUND = 'name_by_id_not_found',
    DOMAINNOTALLOWED = 'domainnotallowed',
    DOMAIN_NOT_FOUND = 'domain_not_found',
    EXISTS_AUTOMATIC_DOMAIN = 'exists_automatic_domain',
    AUTOMATIC_DOMAIN_BY_ID_NOT_FOUND = 'automatic_domain_by_id_not_found',
    DOMAIN_ALREADY_EXISTS_CLOUDFLARE = 'domain_already_exists_cloudflare',
    DOMAIN_ALREADY_EXISTS = 'domain_already_exists'
}

// Interface cho response từ apiClient
export interface ApiResponse<T = any> {
    ok: boolean;
    status: number;
    statusText: string;
    data?: T;
}

// Interface cho response từ backend
export interface BackendResponse<T = any> {
    status: StatusResponse;
    message: string;
    data?: T;
    column?: string;
}

// Interface cho login response
export interface LoginResponse extends BackendResponse {
    accessToken: string;
    refreshToken: string;
    userId: string;
    role: any;
    permission: any;
    userData: {
        _id: string;
        username: string;
        name: string;
    };
}

// Interface cho refresh token response
export interface RefreshTokenResponse extends BackendResponse {
    accessToken: string;
}

// Interface cho user info response
export interface UserInfoResponse extends BackendResponse {
    _id: string;
    username: string;
    name: string;
    email: string;
    role: any;
    permission: any;
}
